import React from "react";

/**
 * Hook para gerenciamento de múltiplos loadings.
 * @returns object
 */
export function useLoading() {

    const [loading, setLoading] = React.useState<Record<string, number>>({});

    //Iniciar um loading identificado por uma chave
    const startLoading = React.useCallback((key: string) => {
        setLoading(prev => ({ ...prev, [key]: (prev[key] || 0) + 1 }));
    }, []);

    //Finaliza um loading identificado por uma chave
    const stopLoading = React.useCallback((key: string) => {
        setLoading(prev => {
            const current = prev[key] || 0;
            const count = Math.max(current - 1, 0);
            if (count === 0) {
                const { [key]: _, ...rest } = prev;
                return rest;
            }
            return { ...prev, [key]: count };
        });
    }, []);

    //Retorna se o loading está ativo
    const isLoading = React.useCallback((key: string | string[]) => {
        if (Array.isArray(key)) {
            return key.some(k => !!loading[k]);
        }
        return !!loading[key]
    }, [loading]);

    //Retorna se há algum loading ativo
    const anyLoading = React.useCallback(() => Object.values(loading).some(count => count > 0), [loading]);

    return { loading, startLoading, stopLoading, isLoading, anyLoading };
}